import { Typography } from '@mui/material'
import React, { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { isFeuilleDeMatchFull } from '../../utils/feuilleMatch.js'
import { EMPTY_PLAYER } from '../../utils/helpers.js'
import { GAME_FACT_HANDBALL_GOAL} from '../constants.js'
import TextCustom from '../generic/textCustom.js'
import { useGameFact } from '../useGameFact.js'
import { getVisualTimer } from '../../sports/rules.js'

const RecapHandballGoal = ({state, setState, match, onChangeText, onChangeTitle, inHistory}) => {
    const {team, buteur, timer, period, passeur, butSucced} = state
    
    const [img, imgSucceed, imgFailed] = useGameFact({type : GAME_FACT_HANDBALL_GOAL})

    const {homeHolders, homeSubstitutes, awayHolders, awaySubstitutes, homeTeam, awayTeam} = match

    let allPlayers = isFeuilleDeMatchFull(match) ? [...homeHolders, ...homeSubstitutes, ...awayHolders, ...awaySubstitutes] : [...match.homeTeam.players, ...match.awayTeam.players]

    let buterPlayer = allPlayers.find(p => p._id === buteur) ?? EMPTY_PLAYER
    let passeurPlayer = !passeur ? undefined : allPlayers.find(p => p._id === passeur) ?? EMPTY_PLAYER

    let teamSelected = [homeTeam, awayTeam].find(t => t._id === team)

    const actualPeriod = period ??  match.period

    // Gestion du text
    useEffect(() => {
        if(!state.text || state.edited){
            const monText = buteur === 'csc' 
            ? 'But contre son camp! ' + (butSucced ? "" : "Malheureusement le but a été refusé.") 
            : `But de ${buterPlayer.lastname !== '...' ? buterPlayer.lastname + ' ' : ''}` 
                + (passeurPlayer && passeur ? "sur une passe décisive de "+passeurPlayer.lastname : "") 
                + '! ' 
                + (butSucced ? "" : "Malheureusement le but a été refusé.");

            
            if(!inHistory)
                onChangeText && onChangeText(monText)
        }

        if(!state.title || state.edited){
            const monTitle = 'BUT'
            
            if(!inHistory){
                onChangeTitle && onChangeTitle(monTitle)
            }
                
        }
    }, [])

    

    return (
        <div style={{color : inHistory ? 'black' : 'white'}}>
             <img src={butSucced? imgSucceed : imgFailed} width={150}/>
            <Typography>Equipe : {teamSelected.name}</Typography>
            <Typography>
                {buteur === 'csc' 
                    ? 'Contre son camp ' + (butSucced ? `(Validé)` : `(Refusé)`)
                    : `${buterPlayer.lastname !== '...' ? buterPlayer.lastname + ' ' : ''}` 
                        + (butSucced ? `(Validé)` : `(Refusé)`) }
            </Typography>
            {passeurPlayer && <Typography>Passeur : {passeurPlayer.lastname}</Typography>}
            {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}
           
            {state.title && <TextCustom initialText={state.title} onChangeText={onChangeTitle} label={'Titre'}/>}
            {state.text && <TextCustom initialText={state.text} onChangeText={onChangeText} label={'Texte'}/>}
        </div>
    )
}

export default RecapHandballGoal